<template>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-8">
        <c-card title="Editar autoridad regulatoria">
          <autoridad-form />
        </c-card>
      </div>
    </div>
  </div>
</template>
<script>
import AutoridadForm from "@/components/Forms/AutoridadForm.vue";
import CCard from "@/components/CCard.vue";
export default {
  components: {
    AutoridadForm,
    CCard,
  },
};
</script>
